/* GENERAL */
export const GET_GENERAL = "GET_GENERAL"
export const GET_GENERAL_SUCCESS = "GET_GENERAL_SUCCESS"
export const GET_GENERAL_FAIL = "GET_GENERAL_FAIL"

export const SEARCH_GENERAL = "SEARCH_GENERAL"
export const SEARCH_GENERAL_SUCCESS = "SEARCH_GENERAL_SUCCESS"
export const SEARCH_GENERAL_FAIL = "SEARCH_GENERAL_FAIL"

export const SET_CURRENT_USER = "SET_CURRENT_USER"

export const GET_COUNTRY = "GET_COUNTRY"
export const GET_COUNTRY_SUCCESS = "GET_COUNTRY_SUCCESS"
export const GET_COUNTRY_FAIL = "GET_COUNTRY_FAIL"

export const GET_STATE = "GET_STATE"
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS"
export const GET_STATE_FAIL = "GET_STATE_FAIL"

export const GET_CITY = "GET_CITY"
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS"
export const GET_CITY_FAIL = "GET_CITY_FAIL"

export const GET_REGION = "GET_REGION"
export const GET_REGION_SUCCESS = "GET_REGION_SUCCESS"
export const GET_REGION_FAIL = "GET_REGION_FAIL"

export const GET_ATTACHMENT = "GET_ATTACHMENT"
export const GET_ATTACHMENT_SUCCESS = "GET_ATTACHMENT_SUCCESS"
export const GET_ATTACHMENT_FAIL = "GET_ATTACHMENT_FAIL"

export const GET_PROFILE_ATTACHMENT = "GET_PROFILE_ATTACHMENT"
export const GET_PROFILE_ATTACHMENT_SUCCESS = "GET_PROFILE_ATTACHMENT_SUCCESS"
export const GET_PROFILE_ATTACHMENT_FAIL = "GET_PROFILE_ATTACHMENT_FAIL"

export const GET_THUMBNAIL_ATTACHMENT = "GET_THUMBNAIL_ATTACHMENT"
export const GET_THUMBNAIL_ATTACHMENT_SUCCESS = "GET_THUMBNAIL_ATTACHMENT_SUCCESS"
export const GET_THUMBNAIL_ATTACHMENT_FAIL = "GET_THUMBNAIL_ATTACHMENT_FAIL"

export const GET_VOUCHER_LIST = "GET_VOUCHER_LIST"
export const GET_VOUCHER_LIST_SUCCESS = "GET_VOUCHER_LIST_SUCCESS"
export const GET_VOUCHER_LIST_FAIL = "GET_VOUCHER_LIST_FAIL"

export const SEND_EMAIL = "SEND_EMAIL"
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS"
export const SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL"

export const GET_ADVERT_INTEREST_RATE = "GET_ADVERT_INTEREST_RATE";
export const GET_ADVERT_INTEREST_RATE_SUCCESS = "GET_ADVERT_INTEREST_RATE_SUCCESS";
export const GET_ADVERT_INTEREST_RATE_FAIL = "GET_ADVERT_INTEREST_RATE_FAIL";

export const ACCEPT_INVITATION = "ACCEPT_INVITATION";
export const ACCEPT_INVITATION_SUCCESS = "ACCEPT_INVITATION_SUCCESS";
export const ACCEPT_INVITATION_FAIL = "ACCEPT_INVITATION_FAIL";

export const RESET_GENERAL_STATE = 'RESET_GENERAL_STATE';

export const RESET_ATTACHMENT_STATE = 'RESET_ATTACHMENT_STATE';

export const RESET_PROFILE_ATTACHMENT_STATE = 'RESET_PROFILE_ATTACHMENT_STATE';

export const RESET_THUMBNAIL_ATTACHMENT_STATE = 'RESET_THUMBNAIL_ATTACHMENT_STATE';

export const RESET_EMAIL_STATE = 'RESET_EMAIL_STATE';

export const RESET_REGION_STATE = 'RESET_REGION_STATE';
